import { connect } from 'react-redux';
import { setUpcomingTracks } from 'actions/player-actions';
import LatestPodcastEpisode from './PodcastLatestEpisode';

const mapDispatchToProps = {
  setUpcomingTracks,
};

export default connect(null, mapDispatchToProps)(LatestPodcastEpisode);
